var _path, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
    fill: "#BF3B2B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5782_4984",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 36,
    height: 36,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5782_4984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3801 14.8248L21.7977 21.0347L22.005 24.1559C22.0072 24.4769 22.0575 24.7958 22.1545 25.1023C22.4049 25.6972 23.0073 26.0752 23.6626 26.0488L33.6484 25.3955C34.0809 25.3885 34.4985 25.5502 34.8093 25.8452C35.0683 26.0911 35.2356 26.4127 35.2884 26.7586L35.3061 26.9686C34.8928 32.6906 30.6903 37.4633 24.9801 38.6953C19.2698 39.9272 13.4143 37.3247 10.5925 32.3006C9.77905 30.841 9.27094 29.2367 9.09803 27.5818C9.02581 27.0919 8.99401 26.597 9.00293 26.102C8.99401 19.9674 13.3627 14.6637 19.478 13.3851C20.214 13.2705 20.9355 13.6601 21.2307 14.3316C21.307 14.487 21.3574 14.6536 21.3801 14.8248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M38.9993 20.7184L38.9888 20.7673L38.9585 20.8384L38.9627 21.0336C38.9471 21.292 38.8472 21.5407 38.6753 21.7417C38.4961 21.951 38.2513 22.0935 37.9817 22.1488L37.8173 22.1713L26.2961 22.9179C25.9129 22.9557 25.5313 22.8321 25.2464 22.578C25.0088 22.366 24.857 22.0801 24.8141 21.772L24.0409 10.2676C24.0274 10.2287 24.0274 10.1865 24.0409 10.1476C24.0514 9.8305 24.191 9.53076 24.4285 9.31534C24.6658 9.09993 24.9814 8.9868 25.3043 9.00123C32.1442 9.17524 37.8928 14.0937 38.9993 20.7184Z",
    fill: "#E0ABA3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/dashboard-active.9112b30d1480231f212c71af184413c4.svg";
export { ForwardRef as ReactComponent };